
const initialState = {}

export function junkDrawerReducer(state = initialState, action: { type: string, payload: Array<{ key: string, value: any }> }) {

    switch (action.type) {
        case "UPDATE_JUNK_DRAWER":
            let temp: any = state
            const keys = action.payload
            for (let i = 0; i < keys.length; i++) {
                if (Object.entries(keys[i]).length > 1) {
                    temp[keys[i].key] = keys[i].value
                } else {
                    //@ts-ignore
                    temp[keys[i].key] = !state[keys[i].key] //if no key is passed, expect a boolean to toggle true or false
                }
            }
            return temp
        default:
            return state
    }
}